import { Icon, IconDefinitions } from "../../../../components";
import { InspectionSessionDetailsModel } from "../../../../data/entities";

interface InspectionHeaderCardProps {
  inspection: InspectionSessionDetailsModel;
  inspectionId: string;
  status: {
    variant: string;
    icon: string;
    label: string;
  };
}

export function InspectionHeaderCard({
  inspection,
  inspectionId,
  status,
}: InspectionHeaderCardProps) {
  return (
    <div className="mb-4 bg-white border rounded shadow-sm overflow-hidden">
      <div className={`bg-${status.variant}`} style={{ height: 3 }} />
      <div className="p-4">
        <span
          className={`d-inline-flex align-items-center gap-2 fw-semibold text-uppercase mb-3 px-3 py-1 rounded-pill border text-${status.variant} bg-${status.variant}-subtle border-${status.variant}`}
        >
          <Icon iconName={status.icon} />
          {status.label}
        </span>

        <h5 className="fw-bold mb-1">
          {inspection.reference ?? `Inspection #${inspectionId}`}
        </h5>

        <div className="d-flex align-items-center gap-3 mt-1">
          {inspection.createdDate && (
            <>
              <span className="text-muted small">
                <Icon
                  iconName={IconDefinitions.clock}
                  className="me-1"
                />
                {new Date(inspection.createdDate).toLocaleString()}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}